export default {"id":"09bf9e9c","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}